import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import dayjs from 'dayjs';

import {App} from './App';

// Шрифты кабинета: Onest (sans) + JetBrains Mono (mono).
import '@styles/globals.css';

import 'dayjs/locale/ru';
// Глобально включаем русскую локаль для всех `dayjs().format(...)`.
import '@fontsource-variable/onest';
import '@fontsource-variable/jetbrains-mono';

dayjs.locale('ru');

const container = document.getElementById('root');
if (!container) throw new Error('Missing #root element in index.html');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
